import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import SimpleTable from '../../components/SimpleTable';
import AddServiceOrderDialog from '../../components/AddServiceOrderDialog';
import { StateManager } from '../../utilities/stateManager';



export default function ServiceList(props) {
  const { cust_id, serviceData, customerName, onDataRefresh } = props;
  const [tableData, setData] = React.useState(serviceData || {});
  const [addOpen, setAddOpen] = React.useState(false);

  // Update local state when props change
  React.useEffect(() => {
    setData(serviceData || {});
  }, [serviceData]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setAddOpen(true)}
          >
            Create Service Order
          </Button>
        </Box>
        <SimpleTable {...tableData} linkLocation="_self"/>
      </Grid>

      <AddServiceOrderDialog
        open={addOpen}
        onClose={() => setAddOpen(false)}
        initialCustomer={cust_id ? { id: cust_id, display_name: customerName } : null}
        onCreated={(orderId) => {
          setAddOpen(false);
          if (onDataRefresh) onDataRefresh();
          StateManager.openServiceOrderModal(orderId);
        }}
      />
    </Grid>
  );
}
